import React, { useState, useEffect } from "react";
import baseRequest from "../../utils/baseRequest";
import { DatePicker, Table, Form, Space, Button, Input, Radio } from "antd";

export default function OrdersQuerry() {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState();

  //表头
  const columns = [
    {
      title: "基本信息",
      dataIndex: "base",
      key: "base",
      render: (data) => {
        return (
          <div>
            <p>
              <span className="text-green-400">订单号：</span>
              {data.order_id}
            </p>
            <p>
              <span className="text-green-400">订单状态：</span>
              {data.order_status_desc}
            </p>
            <p>
              <span className="text-green-400">创建时间：</span>
              {data.ct}
            </p>
          </div>
        );
      },
    },
    {
      title: "商品名称",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "金额",
      dataIndex: "cost",
      key: "cost",
      render: (data) => {
        return (
          <div>
            {data.coins !== undefined && <p>{data.coins}金币</p>}
            {data.money !== undefined && <p>¥{data.money / 100}</p>}
          </div>
        );
      },
    },
    {
      title: "支付渠道",
      dataIndex: "payType",
      key: "payType",
    },
    {
      title: "退款方式",
      dataIndex: "refundType",
      key: "refundType",
    },
    {
      title: "购买（双）方",
      dataIndex: "userAndStreamer",
      key: "userAndStreamer",
      render: (data) => {
        return (
          <div>
            <p>
              <span className="text-green-400">用户id：</span>
              {data.user_user_id}
            </p>
            {data.streamer_user_id !== 0 && (
              <p>
                <span className="text-green-400">达人id：</span>
                {data.streamer_user_id}
              </p>
            )}
          </div>
        );
      },
    },
  ];

  //搜索
  const handleQuerry = async (value) => {
    const ordersQuerry = async (type) => {
      try {
        const base = baseRequest();
        //金币订单查询
        const response = await fetch(`/op/vas/${type}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            st: value.time ? Math.floor(value.time[0].valueOf() / 1000) : 0,
            et: value.time ? Math.floor(value.time[1].valueOf() / 1000) : 0,
            user_id: value.user_id ? parseInt(value.user_id, 10) : 0,
            mid: value.mid ? parseInt(value.mid, 10) : 0,
            order_id: value.order_id ? value.order_id : "",
            ...base,
          }),
        });
        const _data = await response.json();
        console.log(_data);
        if (_data.ret === -1) {
          return false;
        }
        const structedData = _data.data.list.map((item, index) => {
          return {
            key: index,
            base: {
              order_id: item.order_id,
              order_status_desc: item.order_status_desc,
              ct: new Date(item.ct * 1000).toLocaleString(),
              ct_origion: item.ct,
            },
            product: item.product_name,
            cost: {
              coins: item?.coins,
              money: item?.money,
            },
            payType: item?.pay_type,
            refundType: item?.refund_type,
            userAndStreamer: {
              user_user_id: item?.user_user_id,
              streamer_user_id: item?.streamer_user_id,
            },
          };
        });
        return structedData;
      } catch (error) {
        console.error(error);
      }
    };
    const coinOrderResult = await ordersQuerry("coin_order_list");
    const orderResult = await ordersQuerry("order_list");
    //合并查询结果，并按时间排序
    if (!coinOrderResult) {
      setData(orderResult);
      return;
    }
    if (!orderResult) {
      setData(coinOrderResult);
      return;
    }
    if (coinOrderResult && orderResult) {
      const allResult = [...coinOrderResult, ...orderResult];
      const finalResult = allResult.sort(
        (a, b) => b.base.ct_origion - a.base.ct_origion
      );
      setData(finalResult);
    }
  };

  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="px-4">
      <h1>订单查询</h1>
      <p className="text-red-400">*以下字段择一填写进行查询</p>
      <Form
        name="querry"
        onFinish={handleQuerry}
        onFinishFailed={onFinishFailed}
      >
        <Space direction="vertical" style={{ marginBottom: 20 }}>
          <Form.Item label="ID" name="user_id" style={{ margin: 0 }}>
            <Input type="number" />
          </Form.Item>
          <Form.Item
            label="mid(开发使用，运营勿用)"
            name="mid"
            style={{ margin: 0 }}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item label="订单号" name="order_id" style={{ margin: 0 }}>
            <Input type="number" />
          </Form.Item>
          <Form.Item label="时间段" name="time" style={{ margin: 0 }}>
            <RangePicker
              showTime={{
                format: "HH:mm",
              }}
              showNow
              format="YYYY-MM-DD HH:mm"
            />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 20 }}
        scroll={{ y: window.innerHeight - 300 }}
      />
    </div>
  );
}
